import { css } from "simplydo/react/styled";
import { H2 } from "simplydo/react/ui/header";
import { Segment } from "simplydo/react/ui/segment";

const styledSegmentClass = css`
  min-height: fit-content !important;
  .icon.image {
    height: inherit !important;
  }
`;

type IEmptyBox = {
  title?: string;
  message?: string;
  children?: any;
  style?: any;
};

function EmptyBox({ title, message, children, style }: IEmptyBox) {
  return (
    <Segment
      className={styledSegmentClass}
      style={style}
      placeholder
      textAlign="center"
    >
      {children || (
        <>
          {title && <H2>{title}</H2>}
          <p>{message}</p>
        </>
      )}
    </Segment>
  );
}

export default EmptyBox;
